import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  Validators,
  ValidatorFn,
  AbstractControl,
  AsyncValidatorFn,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ToolsValidations } from 'src/app/core/tools/tools.validators';
import { ToastService } from 'src/app/shared/services/toast.service';
import { BannerService } from '../banner/banner.service';
import { SessionService } from 'src/app/core/auth/session.service';
import { ApiService } from 'src/app/core/http/api.service';
import { catchError, map, of } from 'rxjs';
import { EventMenuProfileService } from '../profile-menu/profile-menu.service';
import { SharedModule } from 'src/app/shared/modules/primeng.module';
import { TerminosYCondicionesModalComponent } from '../terminos-y-condiciones-modal/terminos-y-condiciones-modal.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-create-account-modal',
  templateUrl: './create-account-modal.component.html',
  styleUrls: ['./create-account-modal.component.css'],
  standalone:true,
  imports: [SharedModule,TerminosYCondicionesModalComponent]
})
export class CreateAccountModalComponent implements OnInit {
  public messageMailError: string = '';
  public sumbmitForm: any;
  public isValidMail: boolean = false;
  public messageUserNameError: string = '';
  public isValidUser: boolean = false;
  public showPassword: boolean = false;
  public isExistError: boolean = false;
  public isSamePassword: boolean = false;
  public messagePasswordError: string = '';
  public showConfirmPassword: boolean = false;
  public checkConfAge: any;
  public checkConfTerm: boolean = false;
  public showTermsConditions: boolean = false;
  public showPrivacyPolicy: boolean = false;
  public logo: string | null = 'assets/images/no-photo-available.png';
  public showTerminosyCondiciones: boolean = false;

  @Input() showModal: boolean = false;

  @Output() hideModal = new EventEmitter<boolean>();

  constructor(
    private readonly authService: AuthService,
    private readonly formBuilder: FormBuilder,
    private readonly toast: ToastService,
    private readonly router: Router,
    private readonly apiService: ApiService,
    private readonly eventMenuProfileService: EventMenuProfileService
  ) {
    this.sumbmitForm = this.formBuilder.group(
      {
        email: new FormControl('', {
          validators: [Validators.required, this.customValidatorEmail()],
          asyncValidators: this.validatorUsedEmail(),
        }),
        userName: new FormControl('', {
          validators: [Validators.required, this.customValidatorUserName()],
          asyncValidators: this.validatorUsedUserName(),
        }),
        password: new FormControl('', [
          Validators.required,
          this.customValidatorPassword(),
        ]),
        confirmPassword: new FormControl('', [
          Validators.required,
          this.passwordsMatchValidator('password', 'confirmPassword'),
        ]),
        confirmAcceptTerms: new FormControl(false, [Validators.required]),
      },
      {
        validators: this.passwordsMatchValidator('password', 'confirmPassword'),
      }
    );
  }

  ngOnInit(): void {
    this.getCoorporateConfiguration();
  }

  public emitHideModal(): void {
    this.showModal = false;
    this.hideModal.emit(this.showModal);
    this.showPassword = false;
    this.showConfirmPassword = false;
    this.sumbmitForm.reset();
  }

  public validateUsedMail(): void {
    this.messageMailError = '';
    // const mail: string = 'erick_andradhee@hotmail.com';
    const mail: string = this.sumbmitForm.get('email')?.value;

    this.authService.ExistEmail(mail).subscribe({
      next: (res: any) => {
        this.messageMailError = '';
        this.isValidMail = true;
      },
      error: (err: any) => {
        this.isValidMail = false;
        if (err.status == 403)
          this.messageMailError =
            'Lo sentimos, ese correo ya está en uso, prueba con otro.';
      },
    });
  }

  public validateUserName() {
    var userName: string = this.sumbmitForm.get('userName')?.value;
    this.messageUserNameError = '';
    if (userName.length < 5 || userName.length > 16) {
      this.messageUserNameError = 'Tu usuario debe tener de 5 a 16 caracteres.';
      return;
    } else if (!RegExp(ToolsValidations.patternUser).test(userName)) {
      this.messageUserNameError =
        'Tu usuario solo puede tener letras y números.';
      return;
    } else if (this.messageUserNameError != '') {
      this.authService.ExistUserName(userName).subscribe({
        next: (res: any) => {
          this.messageUserNameError = '';
          this.isValidUser = true;
        },
        error: (err: any) => {
          if (err.error instanceof Error) {
            console.error('An error occurred:', err.error.message);
          } else {
            console.error(
              `Backend returned code: '${err.status}', message: '${err.message}'`
            );
          }
          this.messageUserNameError =
            'Lo sentimos, ese usuario ya está en uso, prueba con otro.';
          this.isValidUser = false;
          return;
        },
      });
    }

    this.messageUserNameError = '';
  }

  public validateUsedUserName(): void {
    if (this.messageUserNameError != '') return;

    var userName: string = this.sumbmitForm.get('userName')?.value;
    this.authService.ExistUserName(userName).subscribe({
      next: (res: any) => {
        this.messageUserNameError = '';
        this.isValidUser = true;
      },
      error: (err: any) => {
        if (err.error instanceof Error) {
          console.error('An error occurred:', err.error.message);
        } else {
          console.error(
            `Backend returned code: '${err.status}', message: '${err.message}'`
          );
        }
        this.messageUserNameError =
          'Lo sentimos, ese usuario ya está en uso, prueba con otro.';
        this.isValidUser = false;
      },
    });
  }

  public validatePassword(): void {
      const passwordControl = this.sumbmitForm.get('password');
      const password: string = passwordControl?.value || '';
    
      this.isExistError = true;
      this.messagePasswordError = '';

      if (password.length > 16) {
        passwordControl.setValue(password.substring(0, 16));
        return;
      }

      const rules = [
        { condition: password.length < 8, message: 'Utiliza al menos 8 caracteres.' },
        { condition: !RegExp(ToolsValidations.patternLowerCase).test(password), message: 'Utiliza al menos una letra minúscula.' },
        { condition: !RegExp(ToolsValidations.patternUpperCase).test(password), message: 'Utiliza al menos una letra mayúscula.' },
        { condition: !RegExp(ToolsValidations.patternNumber).test(password), message: 'Utiliza al menos un número.' },
        { condition: !RegExp(ToolsValidations.patternUser).test(password), message: 'Tu contraseña no puede tener espacios ni caracteres especiales.' },
      ];

      for (const rule of rules) {
        if (rule.condition) {
          this.messagePasswordError = rule.message;
          return;
        }
      }

      this.isExistError = false;

      if (this.sumbmitForm.get('confirmPassword')?.value) {
        this.validateSamePassword();
      }
  }

  public validateSamePassword(): void {
    var password = this.sumbmitForm.get('password')?.value;
    var confPassword = this.sumbmitForm.get('confirmPassword')?.value;
    if (password === confPassword) {
      this.sumbmitForm.get('confirmPassword')?.setErrors(null);
      this.isSamePassword = true;
    } else {
      this.sumbmitForm.get('confirmPassword')?.setErrors({ incorrect: true });
      this.isSamePassword = false;
    }
  }

  public checkConfirmAcceptTerms(): void {
    console.log('change terms check', this.sumbmitForm.get('confirmAcceptTerms')?.value);
    this.checkConfTerm = this.sumbmitForm.get('confirmAcceptTerms')?.value;
  }

  public submit(): void {
    var userName = this.sumbmitForm.get('userName')?.value;
    var email = this.sumbmitForm.get('email')?.value.toLowerCase();
    var password = this.sumbmitForm.get('password')?.value;
    this.authService.signup(email, password, userName).subscribe(
      (res) => {
        this.toast.showSuccess(
          'Cuenta creada satisfactoriamente',
          'Cuenta creada satisfactoriamente'
        );

        this.showModal = false;
        this.hideModal.emit(this.showModal);
        this.eventMenuProfileService.login();
      },
      (error) => {
        console.error(error);
      }
    );
  }

  private getCoorporateConfiguration(): void {
    // this.showLoadSkeleton.wallet = true;
    // this.showLoadSpin = true;
    this.apiService.getCoorporateCasinoConfig().subscribe({
      next: (res) => {
        this.logo = res.data.logoCasinoUrl;
        // this.showLoadSkeleton.wallet = false;
        // this.showLoadSpin = false;
      },
      error: (err) => console.error(err),
    });
  }

  public showHideTerminosyCondiciones(value: boolean): void {
    this.showTerminosyCondiciones = value;
  }

  public showHidePrivacyPolicy(value: boolean): void {
    this.showPrivacyPolicy = value;
  }

  // public redirectHome(): void{
  //   // Si está en open-game tenemos que borrar la sessión del juego
  //   this.bannerService.changeNameOfBanner(this.session.getItem('casinoName') as string)
  //   const urlWithoutQuery = this.router.url.split('?')[0];
  //   console.log(urlWithoutQuery);
  //   if(urlWithoutQuery === '/app/home/open-game'){
  //     this.deleteCurrentGameSession();
  //   }
  //   //siempre redirigir al home
  //   this.router.navigate(['/app/home'])
  // }

  // private deleteCurrentGameSession(): void{
  //   this.userSession.deleteUserGameSession().subscribe((res)=>{
  //     console.log('destroying session...');
  //     console.log(res);
  //   })
  // }

  private customValidatorUserName(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) return null;

      if (!RegExp(ToolsValidations.patternUser).test(value)) {
        this.isValidUser = false;
        return {
          custom: `Nombre de usuario no puede tener caracteres especiales`,
        };
      }

      if (value.length < 5 || value.length > 20) {
        this.isValidUser = false;
        return { custom: `Nombre de usuario debe tener de 5 – 20 caracteres` };
      }
      this.isValidUser = true;

      return null;
    };
  }

  private validatorUsedUserName(): AsyncValidatorFn {
    return (control) => {
      return this.authService.ExistUserName(control.value).pipe(
        map((result) => {
          this.isValidUser = true;
          return null;
        }),
        catchError((error) => {
          this.isValidUser = false;
          return of({
            custom: `Nombre usuario en uso`,
          });
        })
      );
    };
  }

  private customValidatorEmail(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value;
      if (
        !RegExp(ToolsValidations.patternMailv2).test(value?.toLowerCase()) &&
        !RegExp(ToolsValidations.trimValidator).test(value?.toLowerCase())
      ) {
        this.isValidMail = false;
        return { custom: `Captura un correo electrónico válido` };
      }
      this.isValidMail = true;

      return null;
    };
  }

  private validatorUsedEmail(): AsyncValidatorFn {
    return (control) => {
      return this.authService.ExistEmail(control.value.toLowerCase()).pipe(
        map((result) => {
          this.isValidMail = true;
          return null;
        }),
        catchError((error) => {
          if (
            Array.isArray(error.error?.message) &&
            error.error?.message[0] === 'email must be an email'
          ) {
            this.isValidMail = false;
            return of({ custom: `Captura un correo electrónico válido` });
          }
          
          this.isValidMail = false;
          return of({
            custom: `Correo electrónico en uso`,
          });
        })
      );
    };
  }

  private customValidatorPassword(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) return null;

      if (value.length < 8) return { custom: `Utiliza al menos 8 caracteres.` };

      if (value.length > 16)
        this.sumbmitForm.get('password').setValue(value.substring(0, 16));

      if (!RegExp(ToolsValidations.patternNumber).test(value))
        return { custom: `Utiliza al menos 1 número.` };

      // if (!RegExp(`[!@#$%&*?¿:;,.()+_=\"\'\[-]{1}`).test(value))
      if (!RegExp(`[^A-Za-z0-9]`).test(value))
        return { custom: `Utiliza al menos 1 caracter especial.` };

      if (!RegExp(ToolsValidations.patternUpperCase).test(value))
        return { custom: `Utiliza al menos una letra mayúscula.` };

      if (!RegExp(ToolsValidations.patternLowerCase).test(value))
        return { custom: `Utiliza al menos una letra minúscula.` };

      return null;
    };
  }

  private customValidatorConfirmPassword(): ValidatorFn {
    console.log('facs1');
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) return null;
      console.log(value);
      console.log(this.sumbmitForm.get('password')?.value);
      if (value !== this.sumbmitForm.get('password')?.value)
        return { custom: `Contraseña no es igual.` };

      return null;
    };
  }

  private passwordsMatchValidator(
    pass: string,
    confirmPass: string
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const checkPass = control.get(pass)?.value;
      const checkConfirmPass = control.get(confirmPass)?.value;

      control.get(confirmPass)?.setErrors(null);

      if (checkPass !== checkConfirmPass) {
        control.get(confirmPass)?.setErrors({ incorrect: true });
        return { custom: `Contraseña no es igual.` };
      }

      return null;
    };
  }
}
